export const DraftFeedback = {
    ThumbsUp: 'thumbs_up',
    ThumbsDown: 'thumbs_down',
} as const;

export type DraftFeedback = (typeof DraftFeedback)[keyof typeof DraftFeedback];
